var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"scrollable-container elevation-5"},[_c('v-card-title',[_c('div',[_vm._v("Venue Management System")])]),_c('v-card-text',{staticClass:"scrollable-content text-h5"},[_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }